import axios from "@/libs/api.request";

export const getOverseasOrder = params => {
  return axios.request({
    url: "/shipments/mabang/orders",
    method: "get",
    params
  });
};

export const syncDeliver = data => {
  return axios.request({
    url: "/mabang/syncDeliver",
    method: "post",
    data
  });
};
